export function searchCatalog(id, catalog) {
  if (!catalog) {
    return null
  }
  for (const item of catalog) {
    if (item.id === parseInt(id)) {
      return item;
    }
    if (item.children) {
      const child = searchCatalog(id, item.children);
      if (child) {
        return child;
      }
    }
  }
  return null
}
